/**
 * ApiPlanGate — Shown when the user's plan does NOT include external API access.
 * Displays a marketing card with feature highlights and an upgrade CTA.
 */
import React from 'react';
import { Card, Button, Typography } from 'antd';
import {
  LockOutlined,
  CheckCircleFilled,
  TeamOutlined,
  SendOutlined,
  SyncOutlined,
  SafetyOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './ApiKeys.css';

const { Title, Text } = Typography;

const FEATURES = [
  { icon: <TeamOutlined />, text: 'Manage contacts & addressbooks from your CRM' },
  { icon: <SendOutlined />, text: 'Create & send WhatsApp and email campaigns programmatically' },
  { icon: <SyncOutlined />, text: 'Sync WhatsApp & email templates automatically' },
  { icon: <SafetyOutlined />, text: 'Server-to-server — granular scopes, rate limiting, audit logs' },
];

export default function ApiPlanGate() {
  const navigate = useNavigate();

  return (
    <div className="api-plan-gate">
      <Card className="gate-card" bordered={false}>
        <LockOutlined className="gate-icon" />
        <Title level={3}>API Access — Enterprise Feature</Title>
        <Text type="secondary" style={{ fontSize: 15 }}>
          External API access lets you integrate MessageOS directly with your own systems:
        </Text>

        <div className="gate-features" style={{ marginTop: 24 }}>
          {FEATURES.map((f, i) => (
            <div key={i} className="feature-item">
              <CheckCircleFilled />
              <span>{f.text}</span>
            </div>
          ))}
        </div>

        <Text type="secondary" style={{ display: 'block', marginBottom: 20 }}>
          Available on the <strong>Enterprise</strong> plan.
        </Text>

        <Button
          type="primary"
          size="large"
          onClick={() => navigate('/dashboard/pricing')}
          style={{ minWidth: 200 }}
        >
          Upgrade Plan →
        </Button>
      </Card>
    </div>
  );
}
